import Burger from './components/burger';
import Device from './common/device';
import Accordeon from './components/accordeon';
import faqAccordeon from './components/faqAccordeon';
import Ancre from './components/ancre';
import Diaporama from './components/diaporama';
import Filtre from './components/filtre';
import GoToTop from './components/gototop';
import Phone from './components/phone';
import Timeline from './components/timeline';
import Popin from './components/popin';
import Menu from './components/menu';
import YoutubeCookies from './components/youtubeCookies';
import Bourse from './components/bourse';
import Popupredirection from './components/popupredirection';
import EventsFilters from './components/eventsFilters';
import Multiplequotes from './components/multiplequotes';

String.prototype.removeAccent = function () {
    let accent = [
        /[\300-\306]/g, /[\340-\346]/g, // A, a
        /[\310-\313]/g, /[\350-\353]/g, // E, e
        /[\314-\317]/g, /[\354-\357]/g, // I, i
        /[\322-\330]/g, /[\362-\370]/g, // O, o
        /[\331-\334]/g, /[\371-\374]/g, // U, u
        /[\321]/g, /[\361]/g, // N, n
        /[\307]/g, /[\347]/g, // C, c
    ];
    let noaccent = ['A', 'a', 'E', 'e', 'I', 'i', 'O', 'o', 'U', 'u', 'N', 'n', 'C', 'c'];

    let str = this;
    for (let i = 0; i < accent.length; i++) {
        str = str.replace(accent[i], noaccent[i]);
    }

    return str;
}

Element.prototype.parents = function (selector = "") {
    let parents = [];
    let item = this.parentElement;

    while (item) {
        if (selector == "" || item.matches(selector)) {
            parents.push(item);
        }
        item = item.parentElement;
    }

    return parents;
}

const main = {
    init: function () {
        Device.init();
        Diaporama.init();
        Timeline.init();
        Filtre.init();
        Accordeon.init();
        Ancre.init();
        Burger.init();
        Phone.init();
        // GoToTop.init();
        Popin.init();
        Menu.init();
        YoutubeCookies.init();
        Bourse.init();
        Popupredirection.init();
        faqAccordeon.init();
        EventsFilters.init();
        Multiplequotes.init();
    }
}

export default main



// WEBPACK FOOTER //
// ./src/scripts/main.js